export default "__VITE_ASSET__4527519f__"